import React from 'react';

const H2: React.FC = ({ children }) => (
  <h2 className="font-sans text-3xl text-des-green ">{children}</h2>
);

export default H2;
